"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendDataLabelColors = exports.isWhiteNotContrastEnough = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
// TODO remove this when IE11 support is dropped
require("svg-classlist-polyfill");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var helpers_1 = require("../../chartTypes/_chartCreators/helpers");
var dataLabelsHelpers_1 = require("../../chartTypes/_chartCreators/dataLabelsHelpers");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var common_1 = require("../../chartTypes/_util/common");
var setWhiteColor = function (point) {
    point.dataLabel.element.childNodes[0].style.fill = "#fff";
    point.dataLabel.element.childNodes[0].style["text-shadow"] = "rgb(0, 0, 0) 0px 0px 1px";
    point.dataLabel.element.classList.remove("gd-contrast-label");
};
var setBlackColor = function (point) {
    point.dataLabel.element.childNodes[0].style.fill = "#000";
    point.dataLabel.element.childNodes[0].style["text-shadow"] = "none";
    point.dataLabel.element.classList.remove("gd-contrast-label");
};
var setContrastColor = function (point) {
    point.dataLabel.element.childNodes[0].style.fill = "";
    point.dataLabel.element.childNodes[0].style["text-shadow"] = "none";
    point.dataLabel.element.classList.add("gd-contrast-label");
};
var changeDataLabelsColor = function (condition, point) {
    return condition ? setWhiteColor(point) : setContrastColor(point);
};
function getVisiblePointsWithLabel(chart) {
    return flatMap_1.default(helpers_1.getVisibleSeries(chart), function (series) { return series.points; }).filter(function (point) { return point.dataLabel && point.graphic; });
}
function setBarDataLabelsColor(chart) {
    var points = getVisiblePointsWithLabel(chart);
    return points.forEach(function (point) {
        var labelDimensions = dataLabelsHelpers_1.getDataLabelAttributes(point);
        var barDimensions = helpers_1.getShapeAttributes(point);
        var barRight = barDimensions.x + barDimensions.width;
        var barLeft = barDimensions.x;
        var labelLeft = labelDimensions.x;
        if (point.negative) {
            if (labelLeft > barLeft) {
                // labelRight is overlapping bar even it is outside of it
                setWhiteColor(point);
            }
            else {
                setContrastColor(point);
            }
        }
        else {
            if (labelLeft < barRight) {
                setWhiteColor(point);
            }
            else {
                setContrastColor(point);
            }
        }
    });
}
function setColumnDataLabelsColor(chart) {
    var points = getVisiblePointsWithLabel(chart);
    return points
        .filter(function (point) { return point.shapeArgs; }) // skip if shapeArgs missing (such as line points in line/column combo chart)
        .forEach(function (point) {
        var labelDimensions = dataLabelsHelpers_1.getDataLabelAttributes(point);
        var columnDimensions = helpers_1.getShapeAttributes(point);
        var columnTop = columnDimensions.y + columnDimensions.height;
        var columnDown = columnDimensions.y;
        var labelDown = labelDimensions.y;
        if (point.negative) {
            changeDataLabelsColor(labelDown < columnDown, point);
        }
        else if (!helpers_1.isStacked(chart)) {
            changeDataLabelsColor(labelDown > columnTop, point);
        }
        else {
            changeDataLabelsColor(labelDown < columnTop, point);
        }
    });
}
function isWhiteNotContrastEnough(color) {
    // to keep first 17 colors from our default palette with white labels
    var HIGHCHARTS_CONTRAST_THRESHOLD = 530;
    var _a = sdk_ui_vis_commons_1.parseRGBColorCode(color), R = _a.R, G = _a.G, B = _a.B;
    var lightnessHCH = R + G + B;
    return lightnessHCH > HIGHCHARTS_CONTRAST_THRESHOLD;
}
exports.isWhiteNotContrastEnough = isWhiteNotContrastEnough;
function setContrastLabelsColor(chart) {
    var points = getVisiblePointsWithLabel(chart);
    return points.forEach(function (point) {
        if (isWhiteNotContrastEnough(point.color)) {
            setBlackColor(point);
        }
        else {
            setWhiteColor(point);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extendDataLabelColors(Highcharts) {
    Highcharts.Chart.prototype.callbacks.push(function (chart) {
        var type = helpers_1.getChartType(chart);
        var changeLabelColor = function () {
            if (type === sdk_ui_1.VisualizationTypes.BAR) {
                setTimeout(function () {
                    setBarDataLabelsColor(chart);
                }, 500);
            }
            else if (common_1.isOneOfTypes(type, [sdk_ui_1.VisualizationTypes.COLUMN, sdk_ui_1.VisualizationTypes.PIE])) {
                setTimeout(function () {
                    setColumnDataLabelsColor(chart);
                }, 500);
            }
            else if (common_1.isOneOfTypes(type, [sdk_ui_1.VisualizationTypes.HEATMAP, sdk_ui_1.VisualizationTypes.TREEMAP])) {
                setContrastLabelsColor(chart);
            }
        };
        changeLabelColor();
        Highcharts.addEvent(chart, "redraw", changeLabelColor);
    });
}
exports.extendDataLabelColors = extendDataLabelColors;
//# sourceMappingURL=dataLabelsColors.js.map